import React from 'react';

const AlignTextRightIcon = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <g transform="translate(-12.000000, -96.000000)" stroke="none" fillRule="evenodd">
      <path
        d="M12,96 L28,96 L28,98 L12,98 L12,96 Z M12,100 L20,100 L20,101 L12,101 L12,100 Z M12,103 L28,103 L28,105 L12,105 L12,103 Z M12,107 L20,107 L20,108 L12,108 L12,107 Z M12,110 L28,110 L28,112 L12,112 L12,110 Z"
        transform="translate(20.000000, 104.000000) scale(-1, 1) translate(-20.000000, -104.000000)"
      />
    </g>
  </svg>
);

export default AlignTextRightIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-text-right-icon.js